import { render, staticRenderFns } from "./blockSpacList.vue?vue&type=template&id=ea3c31e0&scoped=true"
import script from "./blockSpacList.vue?vue&type=script&lang=js"
export * from "./blockSpacList.vue?vue&type=script&lang=js"
import style0 from "./blockSpacList.vue?vue&type=style&index=0&id=ea3c31e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3c31e0",
  null
  
)

export default component.exports